import { useLang } from '../../../i18n/LanguageContext';
import { commonDict } from '../../../i18n/dictionaries/common';
import styles from './MapSection.module.css';
import mapImage from '../../../assets/map.png';

type MapSectionProps = {
  readonly label?: string;
};

export const MapSection = ({ label }: MapSectionProps): JSX.Element => {
  const { lang } = useLang();
  const resolvedLabel = label ?? commonDict[lang].mapLabel;

  return (
    <section className={styles.map} aria-label={resolvedLabel}>
      <img className={styles.mapImage} src={mapImage} alt={resolvedLabel} />
      <span className={styles.mapPin} aria-hidden />
    </section>
  );
};
